/*
Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Apache License, Version 2.0 (the "License").
You may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locale/en.json';
import zh from './locale/zh.json';
import { getStoredLanguage } from './common/localStorageHelper';

const storedLanguage = getStoredLanguage();

i18n.use(initReactI18next).init({
  lng: storedLanguage,
  fallbackLng: 'en',
  resources: {
    en: {
      translation: en,
    },
    zh: {
      translation: zh,
    },
  },
});
